export const SEARCH_URL = `https://api.mapbox.com/autofill/v1`;

export const ENDPOINT_VALIDATE = 'retrieve';

export const VALIDATE_URL = `${SEARCH_URL}/${ENDPOINT_VALIDATE}`;
